import { useIntl } from 'react-intl'
import { last } from 'ramda'
import { useContextSelector } from 'use-context-selector'

import { TurnListContext } from '../context/TurnListProvider'
import { useOccurrencesModal } from './useOccurrencesModal'
import { useOccurrencesTrees } from './useOccurrencesTrees'
import type { ListsItem } from '../context/TurnListProvider'

export const useInStoreLists = () => {
  const occurrencesModal = useOccurrencesModal()
  const { occurrenceTrees } = useOccurrencesTrees()
  const intl = useIntl()

  const contextMoveInServiceListItemToWaitingList = useContextSelector(
    TurnListContext,
    (turnList) => turnList.moveInServiceListItemToWaitingList
  )

  const contextMoveWaitingListItemToInServiceList = useContextSelector(
    TurnListContext,
    (turnList) => turnList.moveWaitingListItemToInServiceList
  )

  const moveInServiceListItemToWaitingList = (
    inServiceListItem: ListsItem['inService']
  ) => {
    const occurrences = inServiceListItem.service?.motives
      ? last(inServiceListItem.service.motives)?.children
      : occurrenceTrees.POST_OPPORTUNITY.children

    if (occurrences && occurrences.length > 0) {
      occurrencesModal.open({
        modalTitle: intl.messages.whatHappenedInService as string,
        salesAssociate: inServiceListItem.salesAssociate,
        occurrences,
        serviceStartDate: inServiceListItem.service?.startDate,
        onConfirm: (selectedOccurrence) => {
          contextMoveInServiceListItemToWaitingList(
            inServiceListItem,
            selectedOccurrence
          )
        },
      })

      return
    }

    contextMoveInServiceListItemToWaitingList(
      inServiceListItem,
      inServiceListItem.service?.motives
    )
  }

  const moveWaitingListItemToInServiceList = (
    cutInLine: boolean,
    waitingListItem: ListsItem['waiting']
  ) => {
    if (cutInLine) {
      occurrencesModal.open({
        modalTitle: intl.messages.cutInLineQuestion as string,
        salesAssociate: waitingListItem.salesAssociate,
        serviceStartDate: waitingListItem.service?.startDate,
        occurrences: occurrenceTrees.PRE_OPPORTUNITY.children,
        cutInLine,
        onConfirm: (selectedOccurrences) => {
          contextMoveWaitingListItemToInServiceList(
            waitingListItem,
            selectedOccurrences
          )
        },
      })

      return
    }

    contextMoveWaitingListItemToInServiceList(waitingListItem)
  }

  const getListTitle = (initialTitle: string, items: unknown[]) => {
    return `${initialTitle}${items.length ? ` (${items.length})` : ''}`
  }

  return {
    moveInServiceListItemToWaitingList,
    moveWaitingListItemToInServiceList,
    getListTitle,
  }
}
